import moment from "moment";
export const queryToPageQsObj = (query = {}) => {
  let { capacity, layout, type, attrs, styles, keywords } = query;
  const hasDates =
    (query.dates?.start && query.dates?.end) ||
    (query.date_from && query.date_to);
  if (hasDates) {
    if (query.dates) {
      query.dates.start = moment(query.dates.start);
      query.dates.end = moment(query.dates.end);
    } else {
      query.dates = {
        start: moment(query.date_from, "DD/MM/YYYY"),
        end: moment(query.date_to, "DD/MM/YYYY"),
      };
    }
  }
  // console.log({ query })
  return {
    location: query.city_slug.match(/book-venue/) ? null : query.city_slug,
    tag: query.event_type ? query.event_type.value : query.tags,
    page: query.page > 1 ? query.page : undefined,
    sort: query.sort !== "relevance" ? query.sort : undefined,
    center: query.centre,
    region: query.region,
    capacity,
    layout: layout?.join(",") || undefined,
    budget_min: query.budget?.[0],
    budget_max: query.budget?.[1],
    start_date: query.dates?.start?.format("DD/MM/YYYY"),
    end_date: query.dates?.end?.format("DD/MM/YYYY"),
    start_time: hasDates ? query.times?.start : undefined,
    end_time: hasDates ? query.times?.end : undefined,
    type: type?.join(",") || undefined,
    attr: attrs?.join(",") || undefined,
    style: styles?.join(",") || undefined,
    keywords: keywords?.join(",") || undefined,
    sub_plan: query.sub_plan?.join(",") || undefined,
    radius: query.radius > 0 && query.radius,
  };
};

export default (query) => {
  let url = `/book-venue-${query.city_slug.replace(/\/book-venue-/, "")}`;
  url = query.city_slug.match(/book-venue/) ? query.city_slug : "/search";
  const qs = Object.entries(queryToPageQsObj(query))
    .filter(([, v]) => !!v)
    .map(([k, v]) => `${k}=${v}`)
    .join("&")
    .replace("?&", "?");
  // console.log({ qs })
  // return
  // if (query.event_type) url += '/' + query.event_type.value
  // else if (query.tags) url += '/' + query.tags

  if (!qs) return url;
  return url + "?" + qs;
};
